import GlobalState from "src/shared/utilities/globalState";

const triggerConfirmationDialog = options =>
  GlobalState.get("triggerScenario")?.("ContactConfirmation", options);

export default triggerConfirmationDialog;
